import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import './SubscriptionDisclaimerWorkflowStep.scss';
import InputWithButton from '../../Common/InputWithButton/InputWithButton';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import { isValidEmailAddress } from '../../../helpers/validation';
import './RequireMissingProfileInputWorkflowStep.scss';
import { Redirect } from 'react-router-dom';
import Routes from '../../../constants/routes';

class RequireMissingProfileInputWorkflowStep extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: true,
            isFormValid: true,
            isCanceled: false,
            profile: {
                firstName: '',
                lastName: '',
                email: '',
                jobTitle: '',
                countryId: ''
            },
            countries: []
        };
    }

    componentDidMount = () => {
        this.loadFilters();
    }

    loadFilters = async () => {
        try {
            const response = await this.props.userActions.getMissingProfileInputFilters();
            if (response.type === types.GET_MISSING_PROFILE_INPUT_FILTERS_SUCCESS) {
                
                this.setState({
                    profile: {
                        firstName: (response.payload.firstName) ? response.payload.firstName : '',
                        lastName: (response.payload.lastName) ? response.payload.lastName : '',
                        email: (response.payload.email) ? response.payload.email : '',
                        jobTitle: (response.payload.jobTitle) ? response.payload.jobTitle : '',
                        countryId: (response.payload.countryId) ? response.payload.countryId.toString() : ''
                    },
                    countries: response.payload.countries
                });

            } else if (response.type === types.GET_MISSING_PROFILE_INPUT_FILTERS_FAILURE) {
                Notification("error", "Error", "Unable to get login workflow steps.");
            } 
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    validateForm = () => {
        const {
            firstName,
            lastName,
            email,
            jobTitle,
            countryId
        } = this.state.profile;

        if (!(email && email.trim().length > 0 && isValidEmailAddress(email))) {
            Notification("error", 'Email address is not valid', '');
            return false;
        }

        return (
            firstName && firstName.trim().length > 0
            && lastName && lastName.trim().length > 0
            && jobTitle && jobTitle.trim().length > 0
            && countryId && countryId.trim().length > 0
        );
    }

    onContinueClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!this.validateForm()) {
            this.setState({ isFormValid: false });
            return;
        }
        else{
            try {
                const response = await this.props.userActions.saveMissingProfileInput(this.state.profile);
                if (response.type === types.SAVE_MISSING_PROFILE_INPUT_SUCCESS) {
                    // Don't complete the workflow step until the save is successful
                    this.props.accountActions.completeWorkflowStep(this.props.step.name);
                } else if (response.type === types.SAVE_MISSING_PROFILE_INPUT_FAILURE) {
                    Notification("error", "Error", "Problem saving missing required profile input.");
                } 
            } catch (error) {
                Notification("error", "An Error Occurred", error);
            }
        }
    }

    onCancelClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isCanceled: true });
    }

    onCountryChange = (value) => {
        this.setState({ 
            profile: {
                ...this.state.profile,
                countryId: value.toString()
            }
        });
    }

    onFormChange = (e) => {
        this.setState({
            profile: {
                ...this.state.profile,
                [e.target.name]: e.target.value
            }
        });
    }

    render() {
        if(this.state.isCanceled){
            return (<Redirect to={Routes.LoginPage} />);
        }
        const valid = this.state.isFormValid ? "" : "was-validated";
        const className = "require-missing-profile-input " + valid;
        return (
            <LoadingIndicator isLoading={this.state.isLoading} isFullscreen={false}>
                <form onSubmit={this.onContinueClick} className={className} noValidate>
                    <p>Please update the following for your profile.</p>
                    <InputWithButton
                        name="firstName"
                        label="First Name"
                        type="text"
                        placeholder="First Name"
                        value={this.state.profile.firstName}
                        onChange={this.onFormChange}
                        errorMessage="Please enter a first name"
                        isFocused={true}
                        isRequired={true} />
                    <InputWithButton
                        name="lastName"
                        label="Last Name"
                        type="text"
                        placeholder="Last Name"
                        value={this.state.profile.lastName}
                        onChange={this.onFormChange}
                        errorMessage="Please enter a last name"
                        isRequired={true} />
                    <InputWithButton
                        name="email"
                        label="Email Address"
                        type="text"
                        placeholder="Email Address"
                        value={this.state.profile.email}
                        onChange={this.onFormChange}
                        errorMessage="Please enter an email address"
                        isRequired={true} />
                    <InputWithButton
                        name="jobTitle"
                        label="Job Title"
                        type="text"
                        placeholder="Job Title"
                        value={this.state.profile.jobTitle}
                        onChange={this.onFormChange}
                        errorMessage="Please enter a job title"
                        isRequired={true} />
                    <div className="text-left">
                        <MultiSelectBox name="countryId" idField="id" valueField="name"
                            options={this.state.countries}
                            onChange={this.onCountryChange}
                            placeholder="Select a Country"
                            selectedValues={this.state.profile.countryId.toString()}
                            isRequired={true}
                            errorMessage="Country is required"
                            isMulti={false}
                        />                             
                    </div>
                    <div className="buttons d-flex justify-content-between">
                        <button className="btn btn-outline-light me-2" onClick={this.onCancelClick}>Cancel</button>
                        <button className="btn btn-outline-light" onClick={this.onContinueClick}>Continue</button>
                    </div>
                </form>
            </LoadingIndicator>
        );
    }

}

RequireMissingProfileInputWorkflowStep.propTypes = {
    step: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
    accountActions: PropTypes.object.isRequired
};

export default RequireMissingProfileInputWorkflowStep;